import React from 'react';
import { MenuButton, Close } from '../core';
import { MobileMenu } from './MobileMenu';
import { ModalContext } from '../../context/ModalContext';

export const ToggleMenu = (props: any): JSX.Element => {
  const { open, close, modal } = React.useContext(ModalContext);
  return modal ? (
    <Close ml={3} onClick={close} />
  ) : (
    <MenuButton
      ml={3}
      {...props}
      onClick={() => open(<MobileMenu />)}
      aria-label="toggle menu"
    />
  );
};
